import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { AssignShippingDto } from 'src/app/Model/Shipping/assign-shipping-dto';
import { MapOptimizedResponse } from 'src/app/Model/Shipping/map-optimized-response';
import { ServiceManCurrentLocation } from 'src/app/Model/Shipping/service-man-current-location';
import { ShippingSequanceData } from 'src/app/Model/Shipping/shipping-sequance-data';
import { CustomLabel, DistanceAndWeather, Label, LatLong, WayPoint } from 'src/app/Model/Shipping/way-point';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { MapsAPILoader } from '@agm/core';
import { ShippingStatusComponent } from '../shipping-status/shipping-status.component';
import { ShippingDetailsComponent } from '../shipping-details/shipping-details.component';
import { ShippingStartComponent } from '../shipping-start/shipping-start.component';
import { ShippingRatingComponent } from '../shipping-rating/shipping-rating.component';
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from 'src/app/Base/confirmation-dialog/confirmation-dialog.component';
import { getWindow } from 'ssr-window';
import { OtpDialogComponent } from 'src/app/Base/otp-dialog/otp-dialog.component';
import { NewOrderDialogComponent } from '../new-order-dialog/new-order-dialog.component';


@Component({
  selector: 'shipping-manager',
  templateUrl: './shipping-manager.component.html',
  styleUrls: ['./shipping-manager.component.css']
})
export class ShippingManagerComponent implements OnInit, OnDestroy {

  employeeCode: string;
  currentDate: string;
  shippingDetailsList: AllDeliveryDetailsDto[] = [];
  constant: Constant = new Constant();
  pickedUpShippingData: AllDeliveryDetailsDto[] = [];
  startPickedUpShippingData: AllDeliveryDetailsDto[] = [];
  assignShippingDto: AssignShippingDto = new AssignShippingDto();
  isStartConfirmClick: boolean = false;
  isTimerStarted: boolean = false;
  isShowAsignBtn: boolean = true;
  mapOptimizedResponse: MapOptimizedResponse[] = [];
  shippingSequanceData: ShippingSequanceData[] = [];
  shippingSequanceDataMap: ShippingSequanceData[] = [];
  opencart: boolean = false;
  serviceManCurrentLocation: ServiceManCurrentLocation[] = [];
  currLocList: ServiceManCurrentLocation[] = [];
  weatherCondition: string;
  isIntervalApiCall: boolean = true;

  //For Google Map
  latitude: number;
  longitude: number;

  lastLati: number;
  lastLongi: number;
  zoom: number;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  origin: LatLong = new LatLong();
  destination: LatLong = new LatLong();
  waypoints: WayPoint[] = [];
  customLabel: CustomLabel[] = [];
  isShowMap: boolean = false;
  isMapDrawn: boolean = false;

  public renderOptions = {
    suppressMarkers: true,
  };

  markerOptions = {
    origin: { label: { color: 'white', text: 'OD' }, infoWindow: '' },
    destination: {
      visible: true, infoWindow: ''
    },
    waypoints: this.customLabel
  };

  errorLog: ErrorLog = new ErrorLog();

  //Subscription
  private shippingDetailSubscription: Subscription;
  private saveShippingSubscription: Subscription;
  private getSequenceDataSubscription: Subscription;
  private deleteSequenceDataSubscription: Subscription;
  private insertServiceManCurrentLocSubscription: Subscription;
  private getTrafficDetailsDetailsSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  private intervalSubscription: Subscription;
  companyCode: number;

  constructor(
    private apiFactory: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private toastService: ToastrService,
    public dialog: MatDialog,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private shippingManagerService: ShippingManagerService,
    private router: Router,
  ) {
    this.employeeCode = JSON.parse(this.persistenceService.get("google_email"));
    // this.employeeCode = '0001-6';
    // this.companyCode = JSON.parse(this.persistenceService.get('userDetail')).company.refNo;
    // this.companyCode = 1;
  }

  ngOnInit(): void {
    this.currentDate = moment(new Date()).format(this.constant.dateFormatForDBServer);
    this.getShippingDetailsByEmployeeIdAndDate();
    this.setServiceManCurrentLocation();
    this.getGoogleMap();
  }

  ngOnDestroy() {
    if (this.shippingDetailSubscription !== undefined)
      this.shippingDetailSubscription.unsubscribe();

    if (this.saveShippingSubscription !== undefined)
      this.saveShippingSubscription.unsubscribe();

    if (this.getSequenceDataSubscription !== undefined)
      this.getSequenceDataSubscription.unsubscribe();

    if (this.deleteSequenceDataSubscription !== undefined)
      this.deleteSequenceDataSubscription.unsubscribe();

    if (this.insertServiceManCurrentLocSubscription !== undefined)
      this.insertServiceManCurrentLocSubscription.unsubscribe();

    if (this.getTrafficDetailsDetailsSubscription !== undefined)
      this.getTrafficDetailsDetailsSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getShippingDetailsByEmployeeIdAndDate() {
    this.shippingDetailsList = [];
    this.pickedUpShippingData = [];

    this.shippingDetailSubscription = this.shippingManagerService.getShippingDetails(this.apiFactory.getDeliveryDetailsByEmployeeIdAndDate, this.employeeCode, this.currentDate).subscribe(data => {
      if (data.length > 0) {
        this.companyCode = data[0].companyCode;
        this.getSequenceData(data, false);
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getShippingDetailsByEmployeeIdAndDate", error);
      });
  }

  getSequenceData(shippingData: AllDeliveryDetailsDto[], isRoute: boolean) {
    this.shippingDetailsList = [];
    this.pickedUpShippingData = [];
    this.isShowAsignBtn = true;
    this.isTimerStarted = false;

    this.getSequenceDataSubscription = this.shippingManagerService.getSequenceData(this.apiFactory.getShippingSequenceData, this.employeeCode).subscribe((data) => {
      if (data.length > 0) {
        this.shippingSequanceData = data;
        this.isTimerStarted = true;
        this.setSequenceData(shippingData);
      }
      else {
        shippingData.forEach(element => {
          if (element.assignedDeliveryDto.status != this.constant.DELIVERY_PICK_UP_CANCELLED &&
            element.assignedDeliveryDto.status != this.constant.DELIVERY_RESCHEDULE && element.assignedDeliveryDto.status != this.constant.RIDER_DECLINED) {
            this.shippingDetailsList.push(element);
          }
          if (element.assignedDeliveryDto.status == this.constant.DELIVERY_PICK_UP) {
            this.pickedUpShippingData.push(element);
          }
        })
        if (this.shippingDetailsList.length == 0) {
          this.toastService.showErrorToast(this.constant.noDataAvailableToast);
          if (isRoute) {
            this.router.navigateByUrl('dashboard');
            this.persistenceService.set('page', 'Dashboard');
          }
        }
        this.isTimerStarted = false;
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getSequenceData", error);
      });
  }

  setSequenceData(data: AllDeliveryDetailsDto[]) {
    this.shippingDetailsList = [];
    this.pickedUpShippingData = [];
    this.startPickedUpShippingData = [];
    // this.shippingSequanceDataMap = [];
    this.isShowAsignBtn = true;
    this.isShowMap = false;
    // this.waypoints = [];
    // this.customLabel = [];

    data.forEach(e => {
      e.seqNo = 9999999999999;
    })
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < this.shippingSequanceData.length; j++) {
        if (data[i].assignedDeliveryDto.invNo == this.shippingSequanceData[j].transactionNo) {
          this.startPickedUpShippingData.push(data[i]);
          if (data[i].assignedDeliveryDto.status == this.constant.DELIVERY_PICK_UP) {
            let element: AllDeliveryDetailsDto = new AllDeliveryDetailsDto();
            element = data[i];
            element.seqNo = this.shippingSequanceData[j].seqNo;
            this.shippingDetailsList.push(element);
            if (!this.isMapDrawn) {
              this.shippingSequanceDataMap.push(this.shippingSequanceData[j]);
            }
          }
        }
      }
      if (data[i].assignedDeliveryDto.status == this.constant.DELIVERED || data[i].assignedDeliveryDto.status == this.constant.ASSIGNED
        || data[i].assignedDeliveryDto.status == this.constant.RE_ASSIGNED || data[i].assignedDeliveryDto.status == this.constant.RIDER_ACCEPTED) {
        let element: AllDeliveryDetailsDto = new AllDeliveryDetailsDto();
        element = data[i];
        element.seqNo = data.length;
        this.shippingDetailsList.push(element);
      }
    }

    this.shippingDetailsList.sort((a, b) => (a.seqNo < b.seqNo ? -1 : 1));
    console.log(this.shippingDetailsList);
    console.log(this.shippingSequanceDataMap)

    if (this.shippingSequanceData.length > 0) {
      // Call drawMapData only if it hasn't been called yet
      if (!this.isMapDrawn) {
        this.drawMapData(this.shippingSequanceDataMap);
        this.isMapDrawn = true;
      }
      this.isShowMap = true;
    } else {
      this.isShowMap = false;
      this.shippingSequanceDataMap = [];
      this.waypoints = [];
      this.customLabel = [];
    }

    this.setServiceManCurrentLocation();
  }

  setShippingDetails(data: AssignShippingDto) {
    // this.shippingDetailsList = [];
    this.pickedUpShippingData = [];

    this.shippingDetailsList.forEach(element => {
      if (element.assignedDeliveryDto.invNo == data.transactionNo) {
        element.assignedDeliveryDto.assignedNo = data.refNo.toString();
        element.assignedDeliveryDto.noOfPackets = data.noOfPacket;
        element.assignedDeliveryDto.status = data.status;
      }
    })

    if (!this.isStartConfirmClick) {
      this.getSequenceData(this.shippingDetailsList, true);
    } else {
      this.setSequenceData(this.shippingDetailsList);
    }
  }

  onStatusClick(shipping: AllDeliveryDetailsDto, status: string) {
    shipping.shippingStatus = status;

    if (status != this.constant.DELIVERED) {
      const dialogRef = this.dialog.open(ShippingStatusComponent, {
        width: '85%',
        height: '60%',
        maxWidth: '552px',
        autoFocus: false,
        data: { shippingData: shipping }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          //off the timer varible isTimerStarted
          this.isTimerStarted = false;
          if (this.shippingDetailsList.filter(e => e.assignedDeliveryDto.status == this.constant.DELIVERY_PICK_UP).length == 1
            && this.pickedUpShippingData.length == 0) {
            this.deleteShippingSequenceData(result);
          }
          else {
            this.setShippingDetails(result);
          }

          //store serviceman current location
          this.insertServiceManCurrentLocation(result);
          //set the array to blank
          //on the timer isTimerStarted
        }
      });
    }
    else {
      const dialogRef = this.dialog.open(OtpDialogComponent, {
        height: '50%',
        width: '346px',
        data: { shippingData: shipping.assignedDeliveryDto.invNo }
      });

      dialogRef.afterClosed().subscribe(finalOTP => {
        if (finalOTP) {
          let finalAmt: number = Math.round(Number(shipping.allOrdersForDeliveryDto.netAmt));
          let cashAmt: number = Number(shipping.allOrdersForDeliveryDto.cashPaid);
          let upiAmt: number = Number(shipping.allOrdersForDeliveryDto.upiPaid);
          let bankAmt: number = Number(shipping.allOrdersForDeliveryDto.bankPaid);
          let cardAmt: number = Number(shipping.allOrdersForDeliveryDto.cardPaid);
          let couponAmt: number = Number(shipping.allOrdersForDeliveryDto.couponPaid);
          let walletAmt: number = Number(shipping.allOrdersForDeliveryDto.walletPaid);
          let gatewayAmt: number = Number(shipping.allOrdersForDeliveryDto.gatewayPaid);
          let swipeAmt: number = Number(shipping.allOrdersForDeliveryDto.swipePaid);
          let paytmAmt: number = Number(shipping.allOrdersForDeliveryDto.paytmPaid);
          let deliveryCharge: number = Number(shipping.allOrdersForDeliveryDto.deliveryCharge);
          let total_amt_byAllTypes: number = Number((cashAmt + upiAmt + bankAmt + cardAmt + couponAmt +
            walletAmt + gatewayAmt + swipeAmt + paytmAmt - deliveryCharge).toFixed(2));

          if (total_amt_byAllTypes < finalAmt) {
            this.toastService.showErrorToast(this.constant.checkPaymentToast);
          } else if (this.pickedUpShippingData.length > 0) {
            this.toastService.showErrorToast(this.constant.deliveryNotAllowedToast);
          } else {
            this.saveDeliverdData(shipping, finalOTP);
          }
        }
      })
    }
  }

  onDetailsClick(shipping: AllDeliveryDetailsDto) {
    if (shipping.assignedDeliveryDto.status == this.constant.DELIVERY_PICK_UP ||
      shipping.assignedDeliveryDto.status == this.constant.RE_ASSIGNED) {
      const dialogRef = this.dialog.open(ShippingDetailsComponent, {
        width: '90%',
        maxHeight: '79%',
        maxWidth: '552px',
        autoFocus: false,
        data: { shippingData: shipping.assignedDeliveryDto.invNo }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          this.shippingDetailsList[this.shippingDetailsList.findIndex(e => e.assignedDeliveryDto.invNo == result.assignedDeliveryDto.invNo)] = result;
        }
      });
    }
  }

  onStartClick() {
    console.log(this.pickedUpShippingData)

    const dialogRef = this.dialog.open(ShippingStartComponent, {
      width: '85%',
      height: '70%',
      maxWidth: '552px',

      autoFocus: false,
      data: { shippingData: this.pickedUpShippingData }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result.length > 0) {
        this.isStartConfirmClick = true;
        this.isTimerStarted = true;
        this.shippingSequanceData = result;
        this.setSequenceData(this.shippingDetailsList);
      }
    });
  }

  drawMapData(shippingSequanceData: ShippingSequanceData[]) {
    this.waypoints = [];
    this.customLabel = [];
    this.isShowAsignBtn = false;
    this.isShowMap = false;
    console.log(shippingSequanceData);
    this.origin.lat = Number(this.shippingSequanceData[0].fromLatitude);
    this.origin.lng = Number(this.shippingSequanceData[0].fromLongitude);
    if (shippingSequanceData.length > 1) {
      shippingSequanceData.forEach(e => {
        let wayPoint: WayPoint = new WayPoint();
        wayPoint.location = new LatLong();
        wayPoint.location.lat = Number(e.toLatitude);
        wayPoint.location.lng = Number(e.toLongitude);
        wayPoint.stopover = false;
        this.waypoints.push(wayPoint);
      })
      this.destination.lat = Number(shippingSequanceData[shippingSequanceData.length - 1].toLatitude);
      this.destination.lng = Number(shippingSequanceData[shippingSequanceData.length - 1].toLongitude);
    }
    else {
      this.destination.lat = Number(shippingSequanceData[0].toLatitude);
      this.destination.lng = Number(shippingSequanceData[0].toLongitude);
      let desturl = "";
      if (this.getOS() == "Android")
        desturl = 'geo:' + this.destination.lat + ',' + this.destination.lng
      else
        desturl = 'https://www.google.com/maps/dir/' + this.origin.lat + ',' + this.origin.lng + '/' + this.destination.lat + ',' + this.destination.lng;
      this.markerOptions.destination.infoWindow = shippingSequanceData[0].toLocationName + "<br><a href=" + desturl + " target='_blank'>View on google maps</a>"
    }
    let index: number;
    if (this.waypoints.length > 0) {
      this.waypoints.forEach((w, i) => {
        let lab: CustomLabel = new CustomLabel();
        lab.label = new Label();
        lab.label.color = 'white';
        lab.label.text = String(i + 1);
        index = i;
        let url = "";
        if (this.getOS() == "Android")
          url = 'geo:' + w.location.lat + ',' + w.location.lng
        else
          url = 'https://www.google.com/maps/dir/' + shippingSequanceData[i].fromLatitude + ',' + shippingSequanceData[i].fromLongitude + '/' + w.location.lat + ',' + w.location.lng + '/@' + w.location.lat + ',' + w.location.lng;
        lab.infoWindow = `
        <h4 style="font-size: 11px;"> ${shippingSequanceData[i].toLocationName}<br>
        ${shippingSequanceData[i].transactionNo}<h4 style="font-size: 11px;margin-top: 14px;">
        <a href="${url}" target='_blank'>View on google maps</a>
        `
        this.customLabel.push(lab);
      })
    }
    else {
      index = 0;
    }

    // let desturl = 'https://www.google.com/maps/place/' + shippingSequanceData[index].fromLocationName + '/@' + shippingSequanceData[index].fromLatitude + ',' + shippingSequanceData[index].fromLongitude;
    // this.markerOptions.destination.infoWindow = `
    // <h4 style="font-size: 11px;"> ${shippingSequanceData[index].toLocationName} <br>
    // <h4 style="font-size: 11px;"> <a href="${desturl}" target='_blank'>View on google maps</a>
    // `

    this.markerOptions.origin.infoWindow = `
    <h4 style="font-size: 11px;"> ${shippingSequanceData[0].fromLocationName}
    `
    this.markerOptions.waypoints = this.customLabel;

    this.isShowMap = true;
  }

  saveDeliverdData(shipping: AllDeliveryDetailsDto, finalOTP: string) {
    this.assignShippingDto.transactionNo = shipping.assignedDeliveryDto.invNo;
    this.assignShippingDto.transactionName = shipping.assignedDeliveryDto.transType;
    this.assignShippingDto.serviceManCode = shipping.assignedDeliveryDto.serviceManCode;
    this.assignShippingDto.fromLocationCode = shipping.locationCode;
    this.assignShippingDto.deliveryDate = moment(shipping.assignedDeliveryDto.deliveryDate).format("YYYY-MM-DD HH:mm");
    this.assignShippingDto.deliverySlot = shipping.assignedDeliveryDto.slot;
    this.assignShippingDto.status = this.constant.DELIVERED;
    this.assignShippingDto.otp = finalOTP;
    this.isTimerStarted = false;

    this.saveShippingSubscription = this.shippingManagerService.saveShipping(this.apiFactory.insertShipping, this.assignShippingDto).subscribe((data: any) => {
      if (data != null) {
        if (this.shippingDetailsList.filter(e => e.assignedDeliveryDto.status == this.constant.DELIVERY_PICK_UP).length == 1)
          this.deleteShippingSequenceData(data);
        else {
          this.toastService.showSuccessToast(this.assignShippingDto.status + " Sucessfully");
          this.isStartConfirmClick = false;
          this.setShippingDetails(data);
        }
      }
      //store serviceman current location
      this.insertServiceManCurrentLocation(data);
      //set the array to blank

      //on the timer isTimerStarted
      // this.isTimerStarted = true;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("saveDeliverdData", error);
      });
  }

  deleteShippingSequenceData(value: AssignShippingDto) {
    this.deleteSequenceDataSubscription = this.shippingManagerService.deleteSequenceData(this.apiFactory.deleteShippingSequenceData, this.employeeCode).subscribe((data) => {
      this.isTimerStarted = false;
      this.intervalSubscription?.unsubscribe();
      // if (data) {
      this.toastService.showSuccessToast(value.status + " Sucessfully");
      this.isStartConfirmClick = false;
      this.isShowMap = false;
      this.isIntervalApiCall = false;
      this.setShippingDetails(value);
      // }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("deleteShippingSequenceData", error);
      });
  }

  onRatingClick(shipping: AllDeliveryDetailsDto) {
    console.log(shipping)

    const dialogRef = this.dialog.open(ShippingRatingComponent, {
      width: '85%',
      height: '55%',
      autoFocus: false,
      data: { shippingData: shipping }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let indexNo: number = this.shippingDetailsList.findIndex(e => e.assignedDeliveryDto.invNo == shipping.assignedDeliveryDto.invNo);
        this.shippingDetailsList.splice(indexNo, 1);
        let data: AssignShippingDto = new AssignShippingDto();
        this.setShippingDetails(data);
      }
    });
  }

  setServiceManCurrentLocation() {
    if (this.isTimerStarted && this.shippingSequanceDataMap.length > 0) {
      if (this.persistenceService.get('OS') == 'Android') {
        this.lastLati = Number(this.persistenceService.get('latitude'));
        this.lastLongi = Number(this.persistenceService.get('longitude'));
      } else {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.lastLati = position.coords.latitude;
            this.lastLongi = position.coords.longitude;
          });
        }
      }

      const source = interval(60000);
      this.intervalSubscription = source.subscribe(val => {
        console.log('interval...', this.lastLati, "==", this.lastLongi)
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
          });
        }
        if (this.latitude && this.longitude && this.isIntervalApiCall) {
          //Call Api
          this.getTrafficDetailsDetailsSubscription = this.shippingManagerService.getTrafficDetails(this.apiFactory.getTrafficDetails, this.lastLati.toString(), this.lastLongi.toString(), this.latitude.toString(), this.longitude.toString(), "Yes", this.companyCode).subscribe((data: DistanceAndWeather) => {
            console.log(data)
            if (data) {
              let currLoc: ServiceManCurrentLocation = new ServiceManCurrentLocation();
              currLoc.onDate = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
              currLoc.currentLongitude = this.longitude.toString();
              currLoc.currentLatitude = this.latitude.toString();
              currLoc.distanceCovered = data.distance.toString();
              currLoc.weatherCondition = data.weather;
              currLoc.trafficDuration = data.trafficDuration.toString();
              currLoc.usedFor = "Shipping Management";
              this.currLocList.push(currLoc);
              this.persistenceService.set("ServicemanCurrentLocData", JSON.stringify(this.currLocList));
              this.lastLati = this.latitude;
              this.lastLongi = this.longitude;
            }
          },
            (error: HttpErrorResponse) => {
              this.insertErrorLog("setServiceManCurrentLocation", error);
            });
        }
        // if (this.lastLongi != this.longitude && this.lastLati != this.latitude) {
        //   this.lastLongi = this.longitude;
        //   this.lastLati = this.latitude;
        // }
      });
    }
  }

  insertServiceManCurrentLocation(value: AssignShippingDto) {
    let currdata: ServiceManCurrentLocation[] = JSON.parse(this.persistenceService.get("ServicemanCurrentLocData"));

    console.log('Shipping Sequance Data Map:', this.shippingSequanceDataMap);

    if (currdata) {
      // Use the deep copy for processing to preserve the original sequence
      this.shippingSequanceDataMap.forEach(item => {
        if (item.transactionNo === value.transactionNo) {
          currdata.forEach(element => {
            element.serviceManID = item.employeeCode;
            element.fromLocCode = item.fromLocCode.toString();
            element.toLocCode = item.toLocCode.toString();
            element.usedForRefNo = item.transactionNo;
          });
        }
      });

      console.log('Updated Current Data:', currdata);

      this.isTimerStarted = false;

      if (currdata.length > 0 && currdata.every(el => el.serviceManID && el.fromLocCode && el.toLocCode && el.usedForRefNo)) {
        this.insertServiceManCurrentLocSubscription = this.shippingManagerService.saveServiceManCurrentLocation(this.apiFactory.insertServiceManCurrentLocation, currdata)
          .subscribe((data) => {
            if (data) {
              this.isTimerStarted = true;
              this.currLocList = [];
              this.persistenceService.remove("ServicemanCurrentLocData");
            }
          },
            (error: HttpErrorResponse) => {
              this.insertErrorLog("insertServiceManCurrentLocation", error);
            });
      }
    }
  }

  getTrafficDetails(fromLat: string, fromLng: string, toLat: string, toLng: string, companyCode: number) {
    this.getTrafficDetailsDetailsSubscription = this.shippingManagerService.getTrafficDetails(this.apiFactory.getTrafficDetails, fromLat, fromLng, toLat, toLng, "Yes", companyCode).subscribe((data: DistanceAndWeather) => {
      console.log(data)
      if (data) {
        this.pickedUpShippingData.forEach((item, index) => {
          let currLoc: ServiceManCurrentLocation = new ServiceManCurrentLocation();

          currLoc.onDate = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
          currLoc.serviceManID = item.assignedDeliveryDto.serviceManCode;
          currLoc.currentLongitude = this.latitude.toString();
          currLoc.currentLatitude = this.longitude.toString();
          currLoc.distanceCovered = data.distance.toString();
          currLoc.weatherCondition = data.weather;
          currLoc.trafficDuration = data.trafficDuration.toString();
          currLoc.fromLocCode = item.locationCode.toString();
          currLoc.toLocCode = item.customerDeliveryDetails.refNo.toString();
          currLoc.usedFor = "Shipping Management";
          currLoc.usedForRefNo = item.assignedDeliveryDto.invNo;
          this.currLocList.push(currLoc);
        })
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTrafficDetails", error);
      });
  }

  //Google map
  getGoogleMap() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      // let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      // autocomplete.addListener("place_changed", () => {
      //   this.ngZone.run(() => {
      //     let place: google.maps.places.PlaceResult = autocomplete.getPlace();

      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }
      //     this.latitude = place.geometry.location.lat();
      //     this.longitude = place.geometry.location.lng();
      //     this.zoom = 12;
      //   });
      // });
    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        // this.zoom = 8;
      });
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }

}
